import dayjs from 'dayjs';

import { MessageType } from 'types/api/message.type';

import { Headline } from 'components/Headline';

import { StyledMessageProps } from './Message.styles';
import * as S from './Message.styles';

type MessageProps = MessageType & StyledMessageProps;

const defaultProps: Partial<MessageProps> = {};

export function Message(props: MessageProps): React.ReactElement {
  const { content, isCustomerMessage, timestamp } = { ...defaultProps, ...props };

  const minutes =
    dayjs(timestamp).minute() < 10
      ? `0${dayjs(timestamp).minute()}`
      : dayjs(timestamp).minute();
  const time = `${dayjs(timestamp).hour()}:${minutes}`;

  return (
    <S.Container>
      <S.Content isCustomerMessage={isCustomerMessage}>
        <Headline tag="p">{content}</Headline>
      </S.Content>

      <S.Time isCustomerMessage={isCustomerMessage}>{time}</S.Time>
    </S.Container>
  );
}
